import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const NotificationOff = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.9999 45.833C27.2916 45.833 29.1666 43.958 29.1666 41.6663H20.8333C20.8333 43.958 22.7083 45.833 24.9999 45.833ZM24.9999 13.5413C30.1874 13.5413 33.3333 17.7497 33.3333 22.9163V23.1247L37.4999 27.2913V22.9163C37.4999 16.5205 34.1041 11.1663 28.1249 9.74967V8.33301C28.1249 6.60384 26.7291 5.20801 24.9999 5.20801C23.2708 5.20801 21.8749 6.60384 21.8749 8.33301V9.74967C21.3749 9.87467 20.8958 10.0622 20.4374 10.2288L23.8541 13.6455C24.2291 13.6038 24.6041 13.5413 24.9999 13.5413ZM11.2708 6.97884L8.33325 9.91634L14.1874 15.7705C13.1041 17.8538 12.4999 20.2913 12.4999 22.9163V33.333L8.33325 37.4997V39.583H37.9999L41.6249 43.208L44.5624 40.2705L11.2708 6.97884ZM33.3333 35.4163H16.6666V22.9163C16.6666 21.4997 16.9166 20.1663 17.3749 18.958L33.3333 34.9163V35.4163Z"
        fill={color}
      />
    </svg>
  )
}
